import { LOCATION_SUCCESS, LOCATION_START } from "../types/index";

const getLocationSuccess = (location) => {
  return {
    type: LOCATION_SUCCESS,
    location: location,
  };
};

const getLocationStart = (idx) => {
  return {
    type: LOCATION_START,
    idx: idx,
  };
};

export { getLocationSuccess, getLocationStart };
